export const DEFAULT_STAT_TRAIT_ID = 'email';
